import $ from 'jquery'

function availibilityTable() {
  
  var $table = $('#availibility-table');
  
  if( $table.length === 0 ) return;
  
  // Call to BuilderCMS for data
  var settings = {
    "async": true,
    "crossDomain": true,
    "url": "https://buildercms.com/cms/CmsService.svc/UnitDataFeed",
    "method": "POST",
    "data": "[{\r\n \"CommunityId\":\"943\",\r\n \"UserName\":\"oyova\",\r\n\"Password\":\"H5Re83!cf\"\r\n}]"
  }
  $.ajax( settings ).done(function ( data ) {
    // Only show units that are available
    var availableUnits = data.filter( unit => unit.LotStatus === 'Available' )

    $table.DataTable({
      paginate: false,
      lengthChange: false,
      filter: true,
      searching: false,
      paging: false,
      info: false,
      order: [[ 2, "desc" ]],
      data: availableUnits,
      columns: [
        { data: "Unit" },
        { data: "Floorplan" },
        { data: "SqFt" },
        { data: "Bed/Bath" },
        { data: "Bed/Bath" },
        { data: "View" },
        { data: "UnitLink" },
      ],
      columnDefs: [
        { targets: [0, 4, 5, 6], "orderable": false },
        { targets: 0, "width": "70px" },
        { targets: 1, "width": "90px" },
        { targets: 2, "width": "60px" },
        { targets: 3, "width": "90px" },
        { targets: 4, "width": "90px" },
        { targets: 5, "width": "125px" },
        { targets: 6, "width": "170px" },
        {
          render: function ( data, type, row, meta ) {
            return data.split('/', 1)
          },
          targets: 3
        },
        {
          render: function (data, type, row, meta) {
            return data.split('/')[1]
          },
          targets: 4
        },
        {
          render: function ( data, type, row, meta ) {
            return '<a title="download floorplan" href="' + data +'" target="_blank" rel="noopener noreferrer">Download Plan</a>'
          },
          targets: 6
        },
      ],
    })
  });

}

export { availibilityTable }